"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var big = function big() {
  return /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(24), ";height:", (0, _util.rem)(24), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:big;"));
};

var small = function small(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(20), ";height:", (0, _util.rem)(20), ";font-size:", theme.fontSize.small, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:small;"));
};

var xl = function xl(theme) {
  return /*#__PURE__*/(0, _react.css)("width:", (0, _util.rem)(32), ";height:", (0, _util.rem)(32), ";font-size:", theme.fontSize.x2large, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:xl;"));
};

var sizes = {
  big: big,
  small: small,
  xl: xl
};

var base = function base(_ref) {
  var theme = _ref.theme,
      size = _ref.size,
      borderRadius = _ref.borderRadius;
  return /*#__PURE__*/(0, _react.css)("display:inline-flex;justify-content:center;align-items:center;border-radius:", typeof borderRadius === 'string' ? borderRadius : "".concat(borderRadius, "px"), ";background:", theme.color.monochrome.light, " 100% 100%/cover no-repeat;vertical-align:middle;flex-shrink:0;font-size:", theme.fontSize.base, ";line-height:", theme.lineHeight.leadingNormal, ";&:focus{outline:none;}svg{color:", theme.color.monochrome.mediumDark, ";width:75%;height:75%;vertical-align:middle;}", sizes[size](theme), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var notAvatar = function notAvatar(_ref2) {
  var theme = _ref2.theme;
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.monochrome.white, ";background-color:", theme.color.primary.brand, ";text-transform:uppercase;font-weight:", theme.fontWeight.medium, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:notAvatar;"));
};

var styles = {
  base: base,
  notAvatar: notAvatar
};
exports.styles = styles;
//# sourceMappingURL=Avatar.styles.js.map